import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";


export class BuffaloSpinReelController extends SpinReelController {

    private _overlayReels: boolean [] = [];
    private _bdata:WinterHoardParsedGameData;

    constructor(reelId:number) {
        super(reelId);
    }

    protected makeUpStopReelSet(bottomFillUpTotalNum:number, init:boolean):string[] {
        if(this._bdata && this._bdata.mode !== GameMode.NORMAL) {
            this.swapToOriginalSymbol();
        }
        const randomPosition:number = this.randomizeReelSetPosition(this._nextFullReelSet);
        const topFillUp:string[] = this.makeUpStackedSymbolTop(this._stopReelSet[0]);
        const bottomFillUp:string[] = this.makeUpStackedSymbolBottom(this._stopReelSet[this._stopReelSet.length - 1], bottomFillUpTotalNum, init);
        const bottomRandomFillUp:string[] = this.makeUpStopReelSetRandomBottomFillUp(bottomFillUpTotalNum - bottomFillUp.length, init);

        return this._nextFullReelSet.slice(0, randomPosition + 1).concat(topFillUp).concat(this._stopReelSet).concat(bottomFillUp).concat(bottomRandomFillUp);
    }

    public updateGameData(data:WinterHoardParsedGameData):void {
        //this._hData = <HarlequinParsedGameData> data;
        this._overlayReels = data.overlayM1[this._reelId] || [];
        this._gameMode = data.mode;
        this._nextGameMode = data.nextMode;
        this._stopReelSet = data.reels[this._reelId];
        this._bdata = data;
        this._nearWinBigWinReels = [];

        if(data.nextReelSetName && data.nextReelSetName === "FREESPIN_REELSET") {
            //console.log("Getting Reel set for mode: " + data.nextMode);
            this._nextFullReelSet = Helper.getReelSet(data.nextMode, this._reelId);
        }
        else {
            //console.log("Getting Reel set for reelsNextSpin: BASE");
            this._nextFullReelSet = Helper.getReelSet(data.nextReelSetName, this._reelId);
        }

        if(data.mode !== GameMode.NORMAL) {
            //console.log("BUFFALO STOP REEL SET: " + this._reelId);
            //console.log(this._stopReelSet);
            this.swapToOriginalSymbol();
        }



        //this._nextFullReelSet = Helper.getReelSet(data.nextReelSetName, this._reelId);
        //EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName: this._gameMode}));
        //this._nearWinReels = data.nearWinReels.concat();
        //this._nearWinBigWinReels = data.nearWinBigWinReels.concat();
    }

    public swapToOriginalSymbol():void {
        this._overlayReels.forEach((isOverlay, index) => {
            if(isOverlay) {
                this._stopReelSet[index + 1] = "M5";
            }
        });
        //console.log("OVERLAY REELS");
        //console.log(this._overlayReels);
        //console.log("STOP REELS MODIFIED");
        //console.log(this._stopReelSet);
    }

    public getNwDelay(reelId:number):number {
        return this.getNearWinStopDelay(reelId);
    }

    /*public getSpinStopOffset():number {
        if(this._currentState === ReelAnimationState.INACTIVE || this._currentState === ReelAnimationState.IDLE) {
            return 0;
        }

        // check if there is unfinished stacked wilds in the bottom of the stop reel set.
        // When the offset is more than 0, we have to make sure to compensate it from the stop reel set.
        let spinStopOffset:number = 0;
        let bottomSymbol:string = this._stopReelSet[this._stopReelSet.length - 1];
        let parsedStackedName:IParsedStackedSymbolName = StateReelSymbol.parseStackedSymbolName(bottomSymbol, this._reelId);
        if(parsedStackedName.isStacked && parsedStackedName.index < (parsedStackedName.totalNum - 1)) {
            spinStopOffset = parsedStackedName.totalNum - 1 - parsedStackedName.index;
        }

        return Math.max(0, spinStopOffset - GameConfig.instance.SYMBOLS_NUM_IN_REEL[4]);
    }*/
}